import React from 'react'
import PropTypes from 'prop-types'
import Modal from '../../../../../Components/Modal/Modal'
import Button from '../../../../../Components/Buttons/Button'
import { notify } from '../../../../../Helpers/Notifications'

const EmbedModal = ({ close, title, src }) => {
  return (
    <Modal close={close}>
      <div className='embedModal'>
        <h1>Embed this course</h1>
        <p>
          To embed this course into your own website, copy paste the code below
          into your HTML file:{' '}
        </p>
        <div className='code'>
          {`<iframe`}
          <br />
          &nbsp;&nbsp;{`title="${title}"`}
          <br />
          &nbsp;&nbsp;{`src="${src}"`}
          <br />
          &nbsp;&nbsp;{`width="375px"`}
          <br />
          &nbsp;&nbsp;{`height="400px"`}
          <br />
          {`/>`}
        </div>
        <div className='actions'>
          <Button
            onClick={async () => {
              await navigator.clipboard.writeText(`<iframe
            title="${title}"
            src="${src}"
            width="375px"
            height="400px"
          />`)
              notify(
                'success',
                `Successfully copied the embed code for "${title}" to clipboard`,
              )
            }}
            name={'Copy to clipboard'}
            type={'primary'}
          />
        </div>
      </div>
    </Modal>
  )
}

export default EmbedModal

EmbedModal.defaultProps = {
  close: () => {},
}

EmbedModal.propTypes = {
  close: PropTypes.func.isRequired,
}
